import { createContext, useContext } from 'react';

// Mount nodes for the topbar's page-owned zones. `PageHeader` portals the
// active page's title into Z2 (FormantKit `.fk-identity`) and its action
// buttons into Z3a (`.fk-topbar__actions`), so the shell header owns page
// chrome the same way the platform app does — pages render no header row
// of their own. Null until the topbar commits its refs on first paint.
export const PageIdentityContext = createContext<HTMLElement | null>(null);
export const PageActionsContext = createContext<HTMLElement | null>(null);

export function usePageIdentityNode(): HTMLElement | null {
  return useContext(PageIdentityContext);
}

export function usePageActionsNode(): HTMLElement | null {
  return useContext(PageActionsContext);
}
